// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__12aWK","head":"ProcedureTableInfo_head__2XEeA"};